/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export default function Facebook({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      css={{
        ...css`
          color: #002334;
          cursor: pointer;
        `,
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 0C6.939 0 0 6.939 0 15.5C0 24.061 6.939 31 15.5 31C24.061 31 31 24.061 31 15.5C31 6.939 24.061 0 15.5 0ZM15.5 1C23.495 1 30 7.505 30 15.5C30 23.495 23.495 30 15.5 30C7.505 30 1 23.495 1 15.5C1 7.505 7.505 1 15.5 1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.526 9.3091H20V6.4331C20 6.4331 18.662 6.2041 17.383 6.2041C14.713 6.2041 12.967 7.8221 12.967 10.7521V13.3271H10V16.7061H12.967V24.7961H16.621V16.7061H19.344L19.863 13.3271H16.621V11.1351C16.621 10.2101 17.074 9.3091 18.526 9.3091Z"
        fill="currentColor"
      />
    </svg>
  );
}

Facebook.propTypes = {
  css: PropTypes.instanceOf(css),
};
